define('app/views/minicart_view',[
  'app/setup', 'app/collections/minicart_items', 'app/views/minicart_item_view',
  'app/models/minicart_item'
  ],
  function(takhfifan, minicartItems, minicartItemView, minicartItem) {

  takhfifan.MinicartView = takhfifan.BaseView.extend({

    template: ( $('#minicart-template').length > 0 ) ?
      _.template( $('#minicart-template').html() ) : '',

    initialize: function(options) {
      var _this = this;
      this.items = new takhfifan.MinicartItems();
      this.resetItems(options.items);

      this.items.on('destroy', function(item){
        _this.items.remove(item);
        _this.removeItem(item);
        _this.setResetSessionFlag();
      });

      takhfifan.eventHub.on('cart', function(cart) {
        this.model.set('quantity', cart.quantity);
        this.model.set('subtotal', cart.subtotal);
        this.items.reset();
        this.resetItems(cart.items);
        this.$('ul.minicart-items').remove();
        this.render();
      }, this);

      this.render();
    },

    render: function() {
      var _this = this;
      var quantity = this.model.get('quantity') || 0;
      if(quantity>0) {
        $('em.basket-number').text(quantity);
        //$('em.basket-number').show();
      }
      else {
        //$('em.basket-number').hide();
        $('em.basket-number').text('0');
      }
      if (quantity > 0) {
        var itemsList = this.$('ul.minicart-items');

        if (itemsList.length > 0) {
          itemsList.hide().appendTo($('body'));
          this.$el.html( this.template( this.model.toJSON() ) );
          this.$('ul.minicart-items').replaceWith(itemsList);
          itemsList.show();
        } else {
          this.$el.html( this.template( this.model.toJSON() ) );

          this.items.forEach(function(item) {
            _this.addItem(item);
          });
        }

      } else {
        this.$el.html('<p class="empty">'+i18n.t('cart_empty')+"</p>");
      }
      this.$el.closest('.tkh-basket-wrapper').show();
      this.toggleMiniCart();
    },

    addItem: function(item){
      var $item = $('<li></li>');
      $('.shopping-basket .items-list ul').first().append($item);
      new takhfifan.MinicartItemView({el: $item, model: item});
    },

    removeItem: function(item){
      var quantity = this.model.get('quantity') - item.get('quantity');

      var subtotal =
        this.model.get('subtotal') - (item.get('quantity') * item.get('price'));

      this.model.set({'quantity': quantity, 'subtotal': subtotal});
      this.render();
    },


    resetItems: function (items) {
      var _this = this;
      _.each(items, function (item) {
        _this.items.add(new takhfifan.MinicartItem({
          'quantity': item.quantity,
          'name': item.name,
          'productUrl': item.url,
          'thumbUrl': item.thumbUrl,
          'vendorName': item.vendorName,
          'price': item.price,
          'deleteUrl': item.deleteUrl,
          'formKey': takhfifan.formKey,
          'id': item.id,
          'category': item.category
        }));
      });
    },

    toggleMiniCart: function(e){
      var basketToggleWrapper = $(".login-sec .basket .basket-toggle"),
          itemListWrapper = $(".login-sec .basket .shopping-basket");

      $(basketToggleWrapper).off();
      $(basketToggleWrapper).on("click",function(e){
        if (!($(e.target).is(itemListWrapper) || $($(e.target).parents(itemListWrapper)).is(itemListWrapper))) {
          $(itemListWrapper).fadeToggle();
          if(!($('.modal-overlay').hasClass('for-mini-basket'))){
            $('.modal-overlay').addClass('no-close').addClass('for-mini-basket').fadeToggle();
            var miniBasketOverlayBefore = '<div class="mini-basket-overlay-before"></div>';
            if(!($('.mini-basket-overlay-before').length)){
              $('.for-mini-basket').before(miniBasketOverlayBefore);
            }
            takhfifan.eventHub.trigger('ga:sendPageView', {
              title: "minicart",
              path: "/#minicart"
            });
          }
          else{
            $('.modal-overlay').fadeOut();
            setTimeout(function() {
              $('.modal-overlay').removeClass('for-mini-basket');
            }, 500);
            $('.mini-basket-overlay-before').remove();
          }
        }
      });
      $(document).on("click", function(e) {
        if ($(itemListWrapper).is(":visible")) {
          if (!($(e.target).is(basketToggleWrapper) || $($(e.target).parents(basketToggleWrapper)).is(basketToggleWrapper) ||
            $(e.target).is(itemListWrapper) || $($(e.target).parents(itemListWrapper)).is(itemListWrapper))) {
            $(itemListWrapper).fadeOut();
            $('.modal-overlay').fadeOut();
            setTimeout(function() {
              $('.modal-overlay').removeClass('for-mini-basket');
            }, 500);
            $('.mini-basket-overlay-before').remove();
          }
        }
      });
    }
  });
});

